import { Drag } from 'vue-drag-drop';

export default {
  components: {
    Drag,
  },
  methods: {
    allowDrop() {
      return false;
    },
    onDragObj(node) {
      this.$emit('dragTreeNode', node);
    },
    onDragEnd() {
      this.$emit('dragendTreeNode');
    },
    onClickNode(data, node) {
      if (!node.isLeaf) {
        node.expanded = true;
      }
      this.$emit('clickNode', data, node);
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/chart/components/tree/mixins/drag-tree.js